module.exports = __webpack_public_path__ + "static/media/info.dea78f68.svg";